import { test } from 'ramda'

// eslint-disable-next-line import/prefer-default-export
export const isInternalLink = test(/^\/(?!\/)/)



// WEBPACK FOOTER //
// ./src/components/helpers/predicates.js